import * as yup from 'yup';

export const ValidationSchema = () => {
  return yup
    .object({
      securityPin: yup
        .array()
        .of(
          yup
            .string()
            .matches(/^[0-9]/, '')
            .required('')
        )
        .min(5, "Must be exactly 5 digits") // Set minimum length
        .max(5, "Must be exactly 5 digits")
    })
    .required();
};
